import React, { useState, useEffect } from 'react';
import { SpinnerWrap } from './styles';

const Spinner = ({ height, width, color, marginTop }) => {
  return <SpinnerWrap height={height} width={width} color={color} marginTop={marginTop}></SpinnerWrap>;
};

export { Spinner };
